var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { debounce, memoize } from "lodash-es";
import { getTitleWithParentheses } from "../../../../lib/utils/string";
import { generateMethodDocumentMarkdown } from "../../../../lib/utils/dataSchema/generateMethodDocumentMarkdown";
import Markdown from "../../../../lib/builtin/components/Markdown";
import * as style from "./uicore-expr-input-hint.module.css";
import { vueLinkLocalStorage } from "../../../../lib/utils/vue";
export const getHintDescriptionBox = memoize(() => {
  const host = document.createElement('div');
  const host2 = document.createElement('div');
  host.className = `${style.descriptionAnchor}`;
  host.append(host2);
  const inst = new HintDescriptionBox({});
  inst.host = host;
  inst.$mount(host2);
  return inst;
});
const GMDMO = {
  omitTitles: true
};
let HintDescriptionBox = class HintDescriptionBox extends Vue {
  constructor() {
    super(...arguments);
    this.shown = false;
    this.minimized = false;
  }
  created() {
    this.hide = debounce(() => {
      this.shown = false;
    }, 200);
    vueLinkLocalStorage(this, 'HintDescriptionBox', 'minimized');
    const handleGlobalPointer = ev => {
      if (this.host.contains(ev.target)) {
        this.hide.cancel();
        setTimeout(() => this.hide.cancel(), 190); // 拖动选择文字会导致 CodeMirror 异步触发 hide
        return;
      }
      this.hide();
    };
    document.body.addEventListener('pointerdown', handleGlobalPointer, {
      capture: true,
      passive: true
    });
    document.body.addEventListener('pointerup', handleGlobalPointer, {
      capture: true,
      passive: true
    });
    this.$watch(() => this.shown, shown => {
      if (!shown) {
        this.item = null;
        this.$forceUpdate();
        this.host.remove();
        return;
      }
    });
  }
  show(item, itemEl) {
    this.item = item;
    this.shown = true;
    this.hide.cancel();
    this.$forceUpdate();
    const anchor = itemEl.closest('.CodeMirror-hints');
    const rect = anchor.getBoundingClientRect();
    this.host.style.right = `calc(100vw - ${rect.left}px)`;
    this.host.style.top = `${rect.top}px`;
    this.host.style.minHeight = `${rect.height}px`;
    anchor.parentElement.insertBefore(this.host, anchor);
  }
  render() {
    var _item$displayText;
    const h = arguments[0];
    const {
      item
    } = this;
    if (!item) return h("div");
    if (this.minimized) {
      return h("div", {
        "class": style.descriptionMinimizedPlaceholder,
        "attrs": {
          "title": "显示描述"
        },
        "on": {
          "mouseenter": () => {
            this.minimized = false;
          }
        }
      }, [h("i", {
        "class": "fa fa-question-circle",
        "attrs": {
          "aria-hidden": "true"
        }
      })]);
    }
    const {
      dataSchema,
      isMethod: method
    } = item;
    let title = (_item$displayText = item.displayText) !== null && _item$displayText !== void 0 ? _item$displayText : item.text;
    let description = '';
    if (method) {
      title = getTitleWithParentheses(method.id, method.title);
      description = generateMethodDocumentMarkdown(method, GMDMO);
    }
    if (dataSchema) {
      title = getTitleWithParentheses(String(dataSchema.id), dataSchema.title);
      description = dataSchema.description || '';
    }
    return h("div", {
      "class": `CodeMirror-hints ${style.descriptionWrapper}`
    }, [h("div", {
      "class": style.descriptionMinimizeButton,
      "attrs": {
        "title": "隐藏"
      },
      "on": {
        "click": () => {
          this.minimized = true;
          this.shown = false;
        }
      }
    }, [h("i", {
      "class": "fa fa-times"
    })]), h("div", [h("strong", [title])]), h("hr"), h("markdown", {
      "attrs": {
        "source": description,
        "openInNewWindow": true
      }
    })]);
  }
};
HintDescriptionBox = __decorate([Component({
  components: {
    Markdown
  }
})], HintDescriptionBox);
//# sourceMappingURL=getHintDescriptionBox.js.map
